import React from 'react';
import ReactDOM from 'react-dom/client';
import {Spinner} from "@cloudscape-design/components";
import { I18nProvider } from '@cloudscape-design/components/i18n';
import enMessages from '@cloudscape-design/components/i18n/messages/all.en';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import './i18n';
import './logger';
import NoSleep from '@zakj/no-sleep';

import "@cloudscape-design/global-styles/index.css"
import './index.scss';



// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const suspenseFallback = (
  <div className="suspense-container">
    <h3>Press 'Escape' to enter dev mode.</h3>
    <br />
    <Spinner size='large' />
  </div>
);

root.render(
  <React.StrictMode>
    <AppInitWrapper>
      <React.Suspense fallback={suspenseFallback}>
        <I18nProvider messages={[enMessages]}>
          <App />
        </I18nProvider>
      </React.Suspense>
    </AppInitWrapper>
  </React.StrictMode>
);

// Avoid letting the screen sleep so the animation can play indefinitely.
const noSleep = new NoSleep();

// Enable wake lock.
// (must be wrapped in a user input event handler e.g. a mouse or touch handler)
document.addEventListener(
  'click',
  function enableNoSleep() {
    document.removeEventListener('click', enableNoSleep, false);
    noSleep.enable();
  },
  false,
);
